module.exports = __webpack_public_path__ + "22790ea5e25f43b3504abfb5a5744bf4.pdf";